/** Display names for connector slugs, used as a fallback panel title. */
export const CONNECTOR_PLATFORM_NAMES: Record<string, string> = {
  shopify2: "Shopify",
  "shopify-appstore": "Shopify App Store",
  amazonrutter: "Amazon",
  stripe2: "Stripe",
  woocommerce2: "WooCommerce",
  bigcommercerutter: "BigCommerce",
  magento2: "Magento",
  mockify: "Mockify",
  ga: "Google Analytics",
  google_ads2: "Google Ads",
  facebook2: "Meta Ads",
  tiktok: "TikTok",
  codat_accounting: "Codat Accounting",
  xero: "Xero",
  netsuite: "NetSuite",
  quickbooks: "QuickBooks",
};

/**
 * Resolve the active connector slug from the URL: an explicitly selected
 * `platform`, otherwise the slug returned from an OAuth round-trip
 * (`complete-connection` for property selection, then `connectionSucceed`).
 */
export const getConnectionPlatformFromSearchParam = (searchParams: URLSearchParams): string | null => {
  if (searchParams.has("platform")) {
    return searchParams.get("platform");
  }
  if (searchParams.has("complete-connection")) {
    return searchParams.get("complete-connection");
  }
  return searchParams.get("connectionSucceed");
};
